import { useEffect, useRef, useState } from 'react';
const S = {
  wrap: { display:'flex', flexDirection:'column', alignItems:'center', gap:10 },
  videoBox: { width:'100%', maxWidth:320, borderRadius:12, overflow:'hidden', background:'#000' },
  video: { width:'100%', display:'block' },
  img: { width:'100%', maxWidth:320, borderRadius:12 },
  btn: { background:'#F5C518', color:'#000', border:'none', borderRadius:8, padding:'12px 20px', fontWeight:700, cursor:'pointer', fontSize:15, width:'100%', maxWidth:320 },
  btnAlt: { background:'transparent', color:'#aaa', border:'1px solid #444', borderRadius:8, padding:'10px 20px', fontWeight:600, cursor:'pointer', fontSize:13, width:'100%', maxWidth:320 },
  warn: { color:'#f87171', fontSize:13, textAlign:'center' },
};
export default function CameraCapture({ facing, label, onCapture, onCancel }) {
  const videoRef = useRef(null);
  const streamRef = useRef(null);
  const [photo, setPhoto] = useState(null);
  const [error, setError] = useState('');
  const [ready, setReady] = useState(false);
  useEffect(() => {
    let active = true;
    async function start() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: facing }, audio: false });
        if (!active) { stream.getTracks().forEach((t) => t.stop()); return; }
        streamRef.current = stream;
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
          await videoRef.current.play();
        }
        setReady(true);
      } catch (err) {
        setError('No se pudo acceder a la camara. Verifica los permisos del navegador.');
      }
    }
    start();
    return () => {
      active = false;
      if (streamRef.current) streamRef.current.getTracks().forEach((t) => t.stop());
    };
  }, [facing]);
  const takePhoto = () => {
    const video = videoRef.current;
    if (!video) return;
    const canvas = document.createElement('canvas');
    const maxW = 480; // fotos mas livianas (antes 640)
    const scale = Math.min(1, maxW / video.videoWidth);
    canvas.width = video.videoWidth * scale;
    canvas.height = video.videoHeight * scale;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
    const imgData = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
    let sum = 0;
    let sumSq = 0;
    const n = imgData.length / 4;
    for (let i = 0; i < imgData.length; i += 4) {
      const lum = (imgData[i] + imgData[i + 1] + imgData[i + 2]) / 3;
      sum += lum;
      sumSq += lum * lum;
    }
    const mean = sum / n;
    const variance = sumSq / n - mean * mean;
    if (variance < 60) {
      setError('La imagen se ve muy uniforme (posible camara tapada). Intenta de nuevo con buena luz.');
      return;
    }
    setError('');
    const dataUrl = canvas.toDataURL('image/jpeg', 0.5);
    setPhoto(dataUrl);
    if (streamRef.current) streamRef.current.getTracks().forEach((t) => t.stop());
  };
  const retake = () => {
    setPhoto(null);
    setError('');
  };
  return (
    <div style={S.wrap}>
      <div style={S.videoBox}>
        {!photo && <video ref={videoRef} style={S.video} muted playsInline autoPlay />}
        {photo && <img src={photo} alt={label} style={S.img} />}
        </div>
        {error && <div style={S.warn}>{error}</div>}
          {!photo && ready && <button type="button" style={S.btn} onClick={takePhoto}>Tomar foto - {label}</button>}
            {photo && <div style={S.wrap}>
              <button type="button" style={S.btn} onClick={() => onCapture(photo)}>Usar esta foto</button>
                <button type="button" style={S.btnAlt} onClick={retake}>Tomar de nuevo</button>
                  </div>}
                  {onCancel && <button type="button" style={S.btnAlt} onClick={onCancel}>Cancelar</button>}
                    </div>
                    );
                    }
                    
